<script setup lang="ts">
import { computed } from 'vue';
import { ICONS, type IconName } from './icons';

const props = withDefaults(defineProps<{ name: IconName; size?: number | string }>(), {
  size: undefined,
});

const style = computed(() =>
  props.size ? { width: `${props.size}px`, height: `${props.size}px` } : undefined,
);
</script>

<template>
  <!-- Ranglar CSS'dan: stroke=currentColor, fill yo'q (prototip sprite bilan bir xil) -->
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    :style="style"
    v-html="ICONS[name]"
  />
</template>
